<section class="resend_verification-link-form">
  <div class="custom-button-wrapper">
    <h2 class="resend_verification-link-form__title">
      {{ 'resend_verification-link-form.title' | translate }}
    </h2>
  </div>

  <form
    class="resend_verification-link-form__form"
    novalidate
    [formGroup]="form"
    (submit)="onResendVerificationLink()">
    <div>
      <app-custom-input-text
        label="register.form.email"
        placeholder="register.form.email"
        key="email"
        type="text"
        [control]="emailControl"
        [submitted]="isSubmitted(emailControl)"
        [errorsList]="errorFeedbackList.email">
      </app-custom-input-text>
      <mat-hint
        class="resend_verification-link-form__hint resend_verification-link-form__hint_text">
        {{ 'resend_verification-link-form.hint' | translate }}
      </mat-hint>
    </div>

    <app-mui-button
      class="custom-button-wrapper resend_verification-link-form__mui-button"
      type="submit"
      variant="contained"
      color="primary"
      size="large"
      [disabled]="form && !form.valid">
      {{ 'buttons.resend_verification-link' | translate }}
    </app-mui-button>
  </form>
</section>
